let formModel = {
    locales: {en:{},ar:{}},
    permissions:[],
    checkAll:0
}
export default formModel